function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.0904 0C30.2482 0 32 1.75188 32 3.90963V28.0904C32 30.2481 30.2481 32 28.0904 32H3.90963C1.75188 32 0 30.2481 0 28.0904V3.90963C0 1.75188 1.75181 0 3.90963 0H28.0904V0ZM10.0288 26.4549V12.3476H5.33881V26.4549H10.0288ZM26.9375 26.4549V18.3649C26.9375 14.0316 24.6239 12.0158 21.5387 12.0158C19.0509 12.0158 17.9366 13.384 17.3126 14.3449V12.3476H12.6238C12.686 13.6714 12.6238 26.4549 12.6238 26.4549H17.3126V18.5764C17.3126 18.1546 17.3429 17.7331 17.4672 17.4317C17.8056 16.5895 18.5776 15.7171 19.8731 15.7171C21.569 15.7171 22.2485 17.0113 22.2485 18.9069V26.4549H26.9375ZM7.7155 5.54513C6.11088 5.54513 5.0625 6.60006 5.0625 7.98275C5.0625 9.33638 6.079 10.4204 7.65344 10.4204H7.68369C9.319 10.4204 10.3369 9.33638 10.3369 7.98275C10.3066 6.602 9.32187 5.54812 7.7155 5.54513Z",
  fill: "#F0EFF4",
  fillOpacity: 0.3
});

function SvgLinkedInIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linkedIn-icon.e5cf2115.svg";
export { ForwardRef as ReactComponent };